import { useRef, useEffect, useState } from "react";

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  .mg-hub {
    font-family: 'Open Sans', Arial, sans-serif;
    background: #ffffff;
    padding: 40px 24px 56px;
  }

  .mg-hub__title {
    text-align: center;
    color: #c0392b;
    font-size: clamp(1.1rem, 3vw, 1.75rem);
    font-weight: 700;
    margin-bottom: 32px;
    line-height: 1.35;
  }

  .mg-hub__outer {
    max-width: 1200px;
    margin: 0 auto;
  }

  /* ── Desktop grid ── */
  .mg-hub__grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
  }

  /* ── Carousel ── */
  .mg-hub__carousel-wrap {
    overflow: hidden;
    width: 100%;
  }

  .mg-hub__track {
    display: flex;
    gap: 20px;
    transition: transform 0.42s cubic-bezier(0.4,0,0.2,1);
  }

  .mg-hub__slide { flex-shrink: 0; }

  /* ── Nav ── */
  .mg-hub__nav {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin-top: 28px;
  }

  .mg-arrow {
    box-sizing: border-box;
    width: 44px; height: 44px;
    border-radius: 10px;
    border: 2px solid #ffffff;
    background: skyblue;
    color: #fff;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer;
    transition: background 0.2s, color 0.2s;
    padding: 0; flex-shrink: 0;
  }
  .mg-arrow:hover:not(:disabled) { background: deepskyblue; }
  .mg-arrow:disabled { opacity: 0.3; cursor: not-allowed; }

  .mg-hub__dots { display: flex; gap: 8px; align-items: center; }

  .mg-dot {
    width: 8px; height: 8px;
    border-radius: 50%; border: none;
    background: #d0d0d0; cursor: pointer; padding: 0;
    transition: background 0.2s, transform 0.2s;
  }
  .mg-dot--active { background: #c0392b; transform: scale(1.35); }

  /* ══════════ CARD ══════════ */
  .mg-card {
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 16px rgba(0,0,0,0.13);
    position: relative;
    display: flex;
    flex-direction: column;
    height: 430px;
    width: 100%;
    cursor: pointer;
  }

  /* Default face */
  .mg-card__face {
    display: flex; flex-direction: column; flex: 1;
    transition: opacity 0.32s ease;
  }

  .mg-card__img-wrap { flex: 1; overflow: hidden; min-height: 200px; }

  .mg-card__img {
    width: 100%; height: 100%;
    object-fit: cover; display: block;
    transition: transform 0.5s ease;
  }

  .mg-card__footer {
    padding: 0 16px 20px;
    display: flex; flex-direction: column;
    align-items: center; text-align: center;
  }

  .mg-card__octagon-wrap {
    margin-top: -28px; margin-bottom: 12px;
    width: 56px; height: 56px;
    flex-shrink: 0; position: relative; z-index: 2;
  }

  .mg-card__octagon-outer {
    width: 56px; height: 56px;
    background: rgba(255,255,255,0.95);
    clip-path: polygon(30% 0%,70% 0%,100% 30%,100% 70%,70% 100%,30% 100%,0% 70%,0% 30%);
    display: flex; align-items: center; justify-content: center;
  }

  .mg-card__octagon-inner {
    width: 46px; height: 46px;
    clip-path: polygon(30% 0%,70% 0%,100% 30%,100% 70%,70% 100%,30% 100%,0% 70%,0% 30%);
    display: flex; align-items: center; justify-content: center;
  }

  .mg-card__title {
    font-size: 0.92rem; font-weight: 700;
    color: #fff; line-height: 1.4; text-align: center;
  }

  /* Hover overlay */
  .mg-card__over {
    position: absolute; inset: 0;
    padding: 20px 18px;
    display: flex; flex-direction: column;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.32s ease;
    z-index: 3;
  }

  /* Show overlay on hover */
  .mg-card:hover .mg-card__over {
    opacity: 1;
    pointer-events: auto;
  }

  /* Hide default face on hover */
  .mg-card:hover .mg-card__face {
    opacity: 0;
    pointer-events: none;
  }

  .mg-card:hover .mg-card__img { transform: scale(1.05); }

  .mg-card__over-icon {
    display: flex; margin-bottom: 14px;
  }

  .mg-card__over-oct {
    width: 52px; height: 52px;
    background: rgba(255,255,255,0.2);
    clip-path: polygon(30% 0%,70% 0%,100% 30%,100% 70%,70% 100%,30% 100%,0% 70%,0% 30%);
    display: flex; align-items: center; justify-content: center;
  }

  .mg-card__over-heading {
    font-size: 0.76rem; font-weight: 500;
    color: rgba(255,255,255,0.88);
    margin-bottom: 8px; line-height: 1.3;
    text-transform: uppercase; letter-spacing: 0.7px;
  }

  .mg-card__over-desc {
    font-size: 0.95rem; font-weight: 600;
    color: #fff; line-height: 1.55; flex: 1;
  }

  .mg-card__over-link {
    display: inline-flex; align-items: center;
    margin-top: 16px;
    font-size: 0.88rem; font-weight: 700;
    color: #fff; text-decoration: none;
    border: 1.5px solid rgba(255,255,255,0.6);
    padding: 7px 18px; border-radius: 4px;
    width: fit-content;
    transition: background 0.2s;
  }
  .mg-card__over-link:hover { background: rgba(255,255,255,0.2); }

  .mg-card__close {
    position: absolute; top: 10px; right: 10px;
    background: rgba(255,255,255,0.25);
    border: none; color: white;
    width: 28px; height: 28px;
    border-radius: 50%; font-size: 0.7rem;
    cursor: pointer;
    display: flex; align-items: center; justify-content: center;
  }
`;

/* ── Card data ── */
const cards = [
  {
    id: 1, color: "#2B76A7",
    title: "Calculate your CO2 emission saving now!",
    heading: "CO2 emission saving calculator",
    desc: "Calculate Your CO2 Emission Savings Now and Be a Climate Hero! Measure the environmental impact of your electric vehicle journey and see the carbon footprint you're saving in style.",
    link: "https://www.mgmotor.co.in/tools/ev-calculator#co2-calculator",
    img: "https://mgmotor.scene7.com/is/image/mgmotor/zs-img-dsc-0324?$mg-rgb-desktop-image-responsive$",
    icon: (<svg viewBox="0 0 50 50" fill="none" width="30" height="30"><path d="M6 32 L10 22 L16 18 L34 18 L40 22 L44 32" stroke="white" strokeWidth="1.8" strokeLinejoin="round"/><circle cx="14" cy="34" r="4" stroke="white" strokeWidth="1.8"/><circle cx="36" cy="34" r="4" stroke="white" strokeWidth="1.8"/><path d="M4 32 L46 32" stroke="white" strokeWidth="1.8" strokeLinecap="round"/><path d="M21 17 L25 14 L29 17 L29 23 Q29 26 25 27 Q21 26 21 23 Z" stroke="white" strokeWidth="1.5" fill="none"/><path d="M23 20 l1.5 2 3-3" stroke="white" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/></svg>),
  },
  {
    id: 2, color: "#5B9A22",
    title: "Calculate your money saving!",
    heading: "Tax Saving calculator",
    desc: "Counting Coins and Smiles: Calculate Your Money Savings! Discover the electrifying economy of driving an EV, and see how much you're pocketing while zipping around town.",
    link: "https://www.mgmotor.co.in/tools/ev-calculator#tax-saving-calculator",
    img: "https://mgmotor.scene7.com/is/image/mgmotor/zs-img-dsc-0323?$mg-rgb-desktop-image-responsive$",
    icon: (<svg viewBox="0 0 50 50" fill="none" width="30" height="30"><rect x="14" y="16" width="22" height="18" rx="2.5" stroke="white" strokeWidth="1.8"/><path d="M8 21h6M36 21h6M8 29h6M36 29h6" stroke="white" strokeWidth="1.8" strokeLinecap="round"/><path d="M20 12v4M30 12v4M20 34v4M30 34v4" stroke="white" strokeWidth="1.6" strokeLinecap="round"/><circle cx="25" cy="25" r="4" stroke="white" strokeWidth="1.5"/><path d="M23 25h4M25 23v4" stroke="white" strokeWidth="1.3" strokeLinecap="round"/></svg>),
  },
  {
    id: 3, color: "#BFA62A",
    title: "Calculate cost of charging your EV!",
    heading: "Home charging cost calculator",
    desc: "Unlock the Power of Savings: Calculate the Cost of Charging Your EV! Get ready to electrify your budget by figuring out the cost of charging your EV and watch your expenses go down.",
    link: "https://www.mgmotor.co.in/tools/ev-calculator#home-charging-calculator",
    img: "https://mgmotor.scene7.com/is/image/mgmotor/zs-img-dsc-0326?$mg-rgb-desktop-image-responsive$",
    icon: (<svg viewBox="0 0 50 50" fill="none" width="30" height="30"><rect x="10" y="20" width="30" height="22" rx="1.5" stroke="white" strokeWidth="1.8"/><path d="M6 22 L25 10 L44 22" stroke="white" strokeWidth="1.8" strokeLinejoin="round"/><rect x="20" y="30" width="10" height="12" rx="1" stroke="white" strokeWidth="1.5"/><path d="M26 33 L23 37 h3 L23 41" stroke="white" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/></svg>),
  },
  {
    id: 4, color: "#2a9a6e",
    title: "Calculate running cost for your EV!",
    heading: "Running cost calculator",
    desc: "Running on Sunshine: Calculate the Running Cost of Your EV! Find out how much it costs to keep your electric vehicle cruising in style and prepare for a pocket-friendly ride.",
    link: "https://www.mgmotor.co.in/tools/ev-calculator#running-cost-calculator",
    img: "https://mgmotor.scene7.com/is/image/mgmotor/zs-img-dsc-0325?$mg-rgb-desktop-image-responsive$",
    icon: (<svg viewBox="0 0 50 50" fill="none" width="30" height="30"><rect x="17" y="8" width="16" height="26" rx="2.5" stroke="white" strokeWidth="1.8"/><circle cx="25" cy="30" r="1.8" fill="white"/><path d="M22 12h6" stroke="white" strokeWidth="1.5" strokeLinecap="round"/><path d="M19 38 Q25 35 31 38" stroke="white" strokeWidth="1.6" strokeLinecap="round" fill="none"/><path d="M15 42 Q25 37 35 42" stroke="white" strokeWidth="1.6" strokeLinecap="round" fill="none"/></svg>),
  },
];

/* ── Card component — pure CSS :hover, no click toggle ── */
function MGCard({ card }) {
  return (
    <div className="mg-card">
      {/* Default face */}
      <div className="mg-card__face">
        <div className="mg-card__img-wrap">
          <img className="mg-card__img" src={card.img} alt={card.heading} />
        </div>
        <div className="mg-card__footer" style={{ background: card.color }}>
          <div className="mg-card__octagon-wrap">
            <div className="mg-card__octagon-outer">
              <div className="mg-card__octagon-inner" style={{ background: card.color }}>
                {card.icon}
              </div>
            </div>
          </div>
          <p className="mg-card__title">{card.title}</p>
        </div>
      </div>

      {/* Overlay — pure CSS :hover triggers this */}
      <div className="mg-card__over" style={{ background: card.color }}>
        <div className="mg-card__over-icon">
          <div className="mg-card__over-oct">{card.icon}</div>
        </div>
        <p className="mg-card__over-heading">{card.heading}</p>
        <p className="mg-card__over-desc">{card.desc}</p>
        <a
          className="mg-card__over-link"
          href={card.link}
          target="_blank"
          rel="noopener noreferrer"
        >
          Know More ›
        </a>
      </div>
    </div>
  );
}

/* ── Arrow Button ── */
function ArrowBtn({ dir, onClick, disabled }) {
  return (
    <button className="mg-arrow" onClick={onClick} disabled={disabled} aria-label={dir}>
      {dir === "prev"
        ? <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        : <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/></svg>
      }
    </button>
  );
}

/* ── Main ── */
export default function MGCalculatorHub() {
  const [current, setCurrent] = useState(0);
  const [mode, setMode] = useState("grid"); // "grid" | "carousel-2" | "carousel-1"
  const [slideW, setSlideW] = useState(280);
  const outerRef = useRef(null);

  useEffect(() => {
    const update = () => {
      if (!outerRef.current) return;
      const cw = outerRef.current.offsetWidth;
      if (cw >= 900) {
        setMode("grid");
      } else if (cw >= 520) {
        setMode("carousel-2");
        setSlideW((cw - 20) / 2);
      } else {
        setMode("carousel-1");
        setSlideW(cw);
      }
    };
    update();
    const ro = new ResizeObserver(update);
    if (outerRef.current) ro.observe(outerRef.current);
    return () => ro.disconnect();
  }, []);

  useEffect(() => { setCurrent(0); }, [mode]);

  const isGrid = mode === "grid";
  const perPage = mode === "carousel-1" ? 1 : 2;
  const maxIndex = Math.max(0, cards.length - perPage);
  const translateX = current * (slideW + 20);

  return (
    <>
      <style>{css}</style>
      <div className="mg-hub">
        <h2 className="mg-hub__title">
          Empower Your EV Journey: Comprehensive Calculator Hub
        </h2>

        <div className="mg-hub__outer" ref={outerRef}>
          {isGrid ? (
            <div className="mg-hub__grid">
              {cards.map((c) => <MGCard key={c.id} card={c} />)}
            </div>
          ) : (
            <div className="mg-hub__carousel-wrap">
              <div
                className="mg-hub__track"
                style={{ transform: `translateX(-${translateX}px)` }}
              >
                {cards.map((c) => (
                  <div
                    key={c.id}
                    className="mg-hub__slide"
                    style={{ width: slideW, flex: `0 0 ${slideW}px` }}
                  >
                    <MGCard card={c} />
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Arrows + dots always shown (grid has them hidden via nav display:none when grid) */}
          {!isGrid && (
            <div className="mg-hub__nav">
              <ArrowBtn dir="prev" onClick={() => setCurrent((c) => Math.max(0, c - 1))} disabled={current === 0} />
              
              <ArrowBtn dir="next" onClick={() => setCurrent((c) => Math.min(maxIndex, c + 1))} disabled={current === maxIndex} />
            </div>
          )}
        </div>
      </div>
    </>
  );
}